import 'bootstrap/dist/js/bootstrap.min.js';
import 'jspolyfill-array.prototype.find/find.js';
import 'es6-promise/dist/es6-promise.auto.js';
import 'slick-carousel/slick/slick.min.js';
import 'jquery.mmenu.4.7.5/src/js/jquery.mmenu.min.js';
import 'jquery.mmenu.4.7.5/src/js/addons/jquery.mmenu.header.js';

import 'polyfill-array-includes';
import 'es6-object-assign/auto';
import './Polyfill/isFinite';
import * as $ from 'jquery';
import {CountryRestrictionController} from './CountryRestriction/CountryRestrictionController';
import {ContactAndSocialShareFlyOutController} from './FlyOut/ContactAndSocialShareFlyOutController';
import {HeaderSliderController} from './HeaderSlider/HeaderSliderController';
import {initForContainer} from './FlyOut/SocialShareUtility';
import {detectBrowser} from './Utility/BrowserDetectionUtility';
import {detectTouchDevice} from './Utility/TouchDetectionUtility';
import {initTooltips} from './Utility/TooltipUtility';
import {initFancyBox} from './Utility/FancyBoxUtility';
import {initTabs} from './Utility/TabUtility';
import {createMobileNav} from './Navigation/MobileNavUtility';
import Raven from 'raven-js/dist/raven.js';
import {addOpenBigSearchField} from './Navigation/NavSearchFormUtility';
import {initScrollToAnchor, initScrollToTopButton} from './FlyOut/ScrollToTopLink';
import {shrinkText} from './Utility/TextShrinkUtility';
import {initLoginBox} from './LoginStatus/initLoginBox';
import {addNavAdditionalInformationListener} from './Navigation/NavAdditionalInformationListener';
import {PowermailSubmitUtility} from './Utility/PowermailSubmitUtility';
import {initChatBox} from './ChatBox/initChatBox';
import {initNavigationShop} from './NavigationShop/indexNavigationShop';
import {ETracker} from './Tracking/ETracker';
import {CookieBar} from './Components/CookieBar';
import {processSearchWords} from './Utility/SearchWordUtility';
import {injectTagManager} from './Utility/GoogleTagManagerUtility';
import {ContactPersonController} from './ContactPerson/ContactPersonController';

if (module.hot) {
  module.hot.accept();
}

// @ts-ignore Is set by webpack on build time
if (EXECUTE_SENTRY) {
  Raven.config('https://bc23a1bed09e42c4901e84c0b3f2b364@sentry.integration02.andersundsehr.com/5').install();
}

new ContactAndSocialShareFlyOutController(); // has internal document.ready
$(() => {
  new CookieBar();
  // activate only etracker:
  if ($('.js-no-tagmanager').length === 0) {
    injectTagManager(true);
  }
  new HeaderSliderController();
  new CountryRestrictionController();
  new PowermailSubmitUtility();
  new ETracker();
  new ContactPersonController();
  initLoginBox();
  initChatBox();
  initNavigationShop();
  initForContainer($('html'));
  detectBrowser();
  detectTouchDevice();
  initTooltips();
  initFancyBox();
  initTabs();
  createMobileNav();
  addOpenBigSearchField();
  initScrollToTopButton();
  initScrollToAnchor();
  shrinkText();
  addNavAdditionalInformationListener();
  processSearchWords();
});

if ($('.js-fdstLight').length) {
  import(/* webpackChunkName: "DriveSelectionMain" */ './DriveSelection/DriveSelectionMain').then(module => {
    new module.DriveSelectionMain();
  });
}

if ($('.js-fdstVueForm').length) {
  import(/* webpackChunkName: "DriveSelectionMainVueForm" */ './DriveSelection/DriveSelectionMainVueForm').then(module => {
    new module.DriveSelectionMainVueForm();
  });
}

if ($('.js-fdstList').length) {
  import(/* webpackChunkName: "DriveSelectionList" */ './DriveSelection/DriveSelectionList').then(module => {
    new module.DriveSelectionList();
  });
}

if ($('.js-fdstDetail').length) {
  import(/* webpackChunkName: "DriveSelectionDetail" */ './DriveSelection/DriveSelectionDetail').then(module => {
    new module.DriveSelectionDetail();
  });
}

if ($('.js-productPage').length) {
  import(/* webpackChunkName: "ProductDetailPage" */ './ProductDetailPage/ProductDetailPage').then(module => {
    new module.ProductDetailPage();
  });
}

if ($('.js-searchPage').length) {
  import(/* webpackChunkName: "SearchPage" */ './SearchPage/SearchPage').then(module => {
    new module.SearchPage();
  });
}

if ($('.js-productSlider').length) {
  import(/* webpackChunkName: "ProductSliderController" */ './ProductSlider/ProductSliderController').then(module => {
    new module.ProductSliderController();
  });
}
